export enum ELoginMode {
    PROVIDERS = 'providers',
    USERNAME = 'username',
    TOKEN_ID = 'tokenId'
}

export enum ELoginMethods {
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    APPLE = 'apple',
    USERNAME = 'userPassword',
    TOKEN = 'userToken'
}
export type LoginButtonClickWrapper = (
    cb: Function,
    method: ELoginMethods
) => void;
export interface LoginData {
    profileImageUrl?: string;
    userToken?: string;
    userName?: string;
    userPassword?: string;
    authMethod: ELoginMethods;
}
export interface LoginButtonProps {
    callback: () => void;
    text: string;
    type: string;
    children?: JSX.Element | JSX.Element[];
}
export interface PlayersAuthenticationData {
    usernamePasswordOn: boolean;
    usernamePasswordModel: string;
    userTokenOn: boolean;
    userTokenModel: string;
    googleAppSecret: string;
    googleAppId: string;
    googleModel: string;
    googleOn: boolean;
    appleAppSecret: string;
    appleAppId: string;
    appleModel: string;
    appleOn: boolean;
    fbAppSecret: string;
    fbAppId: string;
    fbModel: string;
    fbOn: boolean;
}

export interface LoginPage {
    text: string;
    textColor: string;
    textSize: number;
    textWeight: 'normal' | 'bold' | 'bolder';
    logo: string;
    playerAuthData: PlayersAuthenticationData;
    stopLoader: () => void;
    startLoader: () => void;
    loginResponse: (response: LoginData) => void;
    loginButtonClickWrapper: LoginButtonClickWrapper;
    openInfoModal: (iframeUrl: string) => void;
    width?: string;
    height?: string;
    backgroundColor?: string;
    fontFamily: string;
    privacyPolicyLink?: string;
    termsAndConditionsLink?: string;
    onContactSupport?: () => void;
}
export interface fbLoginResponse {
    picture: {
        data: {
            height: number;
            is_silhouette: boolean;
            url: string;
            width: number;
        };
    };
    accessToken: string;
}
export interface ProvidersModeProps {
    stopLoader: () => void;
    startLoader: () => void;
    playerAuthData: PlayersAuthenticationData;
    loginResponse: (response: LoginData) => void;
    loginButtonClickWrapper: LoginButtonClickWrapper;
    setMode: (mode: ELoginMode) => void;
}
export interface ManualModeProps {
    loginButtonClickWrapper: LoginButtonClickWrapper;
    submit: (response: LoginData) => void;
}
